import { useState } from 'react';

export const useInputFocus = () => {
	const [isFocused, setIsFocused] = useState(false);

	const onBlur = () => setIsFocused(false);
	const onFocus = () => setIsFocused(true);

	return {
		isFocused,
		onBlur,
		onFocus,
	};
};
